export default __webpack_public_path__ + "static/media/no-foreign-transaction-fees.7da28fc4.svg";